// extracted by mini-css-extract-plugin
export default {"background":"HN9DG","language-nl":"_F2RS"};